import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { City } from '../models/City';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private httpClient: HttpClient,
    private storageService: StorageService) { }

  findCityByName(name: String): Observable<City[]> {
    return this.httpClient.get<City[]>(environment.apiUrl + "cities/filtered/" + name);
  }

  getCityById(id: number): Observable<City> {
    return this.httpClient.get<City>(environment.apiUrl + "cities/" + id);
  }


  checkPermission(perm: string) {
    let loggedUSerInfo = this.storageService.getLoggedUser();
    let permission = undefined;
    if (loggedUSerInfo && loggedUSerInfo.permissions) {
      permission = loggedUSerInfo.permissions.find(pp => pp === perm);
    }

    return permission !== undefined;
  }

}  